import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { PopupAreaCoverageComponent } from 'src/app/popup/calculations/area-coverage/area-coverage.component';
import { Draw8dbBoundaryComponent } from 'src/app/popup/draw8db-boundary/draw8db-boundary.component';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidsCoChannelsService } from 'src/app/services/navaids-co-channels.service';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-navaids-co-channels',
  templateUrl: './navaids-co-channels.component.html',
  styleUrls: ['./navaids-co-channels.component.scss'],
  standalone: false
})
export class NavaidsCoChannelsComponent implements OnInit {

  constructor(public navaidsCoChannelService : NavaidsCoChannelsService,
    public menuController : MenuManagementService,
    private popupService : BsModalService,
    private modalService : ModalControlService,
    public tabsService : TabsService) { }

  ngOnInit(): void {
  }

  colapsableLabelFrequency(index : number): void {
    this.navaidsCoChannelService.frequenciesActive[index] = !this.navaidsCoChannelService.frequenciesActive[index];
    if (!this.navaidsCoChannelService.frequenciesActive[index]){
      // remove all selected navaids from this frequency
      for (const navaid of this.navaidsCoChannelService.sameFrequencyNavaids[index]){
        if (navaid.isselected){
          navaid.isselected = false;
          this.navaidsCoChannelService.previousSelectedNavaids.splice(this.navaidsCoChannelService.previousSelectedNavaids.indexOf(navaid), 1);
        }
      }
    }
  }

  open8dbBoundaryPopup() : void{
    if (this.navaidsCoChannelService.previousSelectedNavaids.length != 2){
      this.modalService.showMesssageModal("Incorrect number of selected items","Please select only two NavAids from the list.");
      return;
    }
    const bsModalRef : BsModalRef = this.popupService.show(Draw8dbBoundaryComponent);
  }

  openOverlapPopup() : void {
    if (this.navaidsCoChannelService.previousSelectedNavaids.length < 2){
      this.modalService.showMesssageModal("Incorrect number of selected items","Please select more than 1 NavAid.");
      return;
    }
    const bsModalRef : BsModalRef = this.popupService.show(PopupAreaCoverageComponent);
    bsModalRef.content.title = 'Overlap Plot Options';
    bsModalRef.content.coverage_type = 'OVERLAP';

  }


}
